<template>
  <div class="header_container">
    <!-- level -->
    <level
      :currentLevelIndex="currentLevelIndex"
      :testType="testType"
      :appLevelName="appLevelName"
    ></level>
    <!-- about -->
    <!--    <div class="about_text" @click="goAbout">{{ $t('About_this_level') }}</div>-->
    <div class="about_top">
      <!--      <level :testType="computedTestType"></level>-->
      <div class="about_btn">
        <div
          :class="[pageName == 'practice' ? `about_btn_active` : 'about_btn_left']"
          @click="showPagePaper('practice')"
        >
          {{ $t('Take_practice_test') }}
        </div>
        <div
          :class="[pageName == 'introduce' ? `about_btn_active` : 'about_btn_left']"
          @click="showPagePaper('introduce')"
        >
          {{ $t('About_this_level') }}
        </div>
        <div
          v-if="!isHideFreePractice"
          :class="[pageName == 'vocabulary' ? `about_btn_active` : 'about_btn_left']"
          @click="showPagePaper('vocabulary')"
        >
          {{ $t('Vocabulary') }}
        </div>
        <div v-if="!isHideFreePractice" class="about_btn_left" @click="clickFreePractice">
          {{ $t('free_practice_title') }}
        </div>
        <div v-if="!isHideResource" class="about_btn_left" @click="goLearnResource">
          {{ $t('Learning_resources') }}
        </div>
      </div>
    </div>
    <!-- price -->
    <!--    <div class="container_price" v-if="priceObj.product_currency">-->
    <!--      <div class="container_price_num">-->
    <!--        {{ priceObj.currency_symbol }}{{ priceObj.product_price / priceObj.currency_base }}-->
    <!--      </div>-->
    <!--      <div class="container_price_unit">-->
    <!--        &ensp;&ensp;{{ changeCurrency(priceObj.product_currency.toUpperCase()) }}/-->
    <!--        {{ $t('test_session') }}-->
    <!--      </div>-->
    <!--      <div-->
    <!--        class="container_price_discount"-->
    <!--        v-if="-->
    <!--          !$store.state.user.isCodeUser &&-->
    <!--          priceObj.product_currency !== 'INR' &&-->
    <!--          priceObj.product_currency !== 'RUB'-->
    <!--        "-->
    <!--        @click="buyCodes"-->
    <!--      >-->
    <!--        {{ $t('get_a_discount') }}-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>
<script>
import level from './level'
import { hideResourceList, hideVocabulary } from '@/utils/hskTool'
import analytics from '@/utils/AnalyticsCenter'
import { pathUrl } from '@/config'

const controller = new AbortController()

export default {
  components: {
    level,
  },
  props: {
    priceObj: {
      type: Object,
      default: () => {
        return {
          product_currency: null,
        }
      },
    },
    currencyList: {
      type: Array,
      default: () => [],
    },
    currentLevelIndex: {
      default: 1,
      type: Number,
    },
    testType: {
      default: 1,
      type: Number,
    },
    appLevelName: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      level: this.$route.query.level,
      pageName: 'practice',
      tabArr: [
        {
          name: 'Description',
          selcted: 'Descriptioned',
          label: 'Description',
          icon: '',
        },
        {
          name: 'Test',
          selcted: 'Tested',
          label: 'Test_format',
        },
        {
          name: 'Vocabulary',
          selcted: 'Vocabularyed',
          label: 'Vocabulary',
        },
      ],
      isMobile: false,
    }
  },
  computed: {
    isHideResource() {
      return hideResourceList.some((item) => item === this.level)
    },
    isHideFreePractice() {
      return hideVocabulary.some((item) => item === this.level)
    },
  },
  mounted() {
    console.log(this.priceObj, 'priceObj')
    this.level = this.$route.query.level
    // 隐藏字典
    if (hideVocabulary.some((item) => item === this.level)) {
      this.tabArr.splice(2, 1)
    }

    this.isMobile = window.innerWidth < 768
    window.addEventListener(
      'resize',
      () => {
        this.isMobile = window.innerWidth < 768
      },
      { signal: controller.signal }
    )
  },

  unMounted() {
    controller.abort()
  },
  methods: {
    clickFreePractice() {
      this.$emit('clickFreePractice')
    },
    goLearnResource() {
      this.$emit('goLearnResource')
    },
    showPagePaper(pageName) {
      if (!this.isMobile) {
        this.pageName = pageName
      }

      this.$emit('show-page-paper', pageName)
    },
    changeCurrency(product_currency) {
      console.log('ppppppppp', product_currency, this.currencyList)
      for (let i = 0; i < this.currencyList.length; i++) {
        if (this.currencyList[i].code === product_currency) {
          return this.currencyList[i].description.replace(product_currency, '').trim()
        }
      }
    },
    goAbout() {
      this.$emit('goAbout')
    },
    buyCodes() {
      this.$emit('buyCodes')
    },
  },
}
</script>
<style scopde lang="scss">
.header_container {
  width: 1200px;
  height: 310px;
  border-radius: 12px;
  border: 1px solid #efeff1;
  margin-top: 20px;
  margin-bottom: 20px;
  background: var(--Wohui-White, #fff);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .about_text {
    min-width: 254px;
    padding: 10px 24px;
    color: var(--Wohui-White, #fff);
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    border-radius: 4px;
    background: #faae56;
    cursor: pointer;
    margin-top: 30px;
  }
  .container_price {
    display: flex;
    margin-top: 16px;
    align-items: center;
    &_num {
      color: #000;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
    &_unit {
      color: #000;
      font-size: 14px;
      font-weight: 400;
      line-height: normal;
    }
    &_discount {
      margin-left: 10px;
      color: #faae56;
      cursor: pointer;
      font-family: Inter;
      font-size: 14px;
      font-weight: 700;
      line-height: 15px;
      letter-spacing: 0em;
      text-align: center;
    }
  }

  @media screen and (max-width: 768px) {
    width: 95%;
    height: auto;
    margin-left: auto;
    margin-right: auto;
  }
}
.about_top {
  width: 1200px;
  height: 271px;
  border-radius: 12px;
  //border: 1px solid var(--Wohui-BG-2, #efeff1);
  background: var(--Wohui-White, #fff);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .about_btn {
    display: flex;
    margin-top: 35px;
    &_left {
      min-width: 200px;
      padding: 10px 24px;
      color: #2c2f46;
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      border-radius: 4px;
      border: 0.5px solid var(--Wohui-Grey-3, #b5b5be);
      background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%), #fff;
      margin-right: 31px;
      cursor: pointer;
    }
    &_right {
      min-width: 200px;
      padding: 10px 24px;
      color: var(--Wohui-White, #fff);
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      border-radius: 4px;
      background: #faae56;
      cursor: pointer;
    }
    &_first {
      min-width: 200px;
      padding: 10px 24px;
      color: var(--Wohui-White, #fff);
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      border-radius: 4px;
      background: #faae56;
      margin-right: 31px;
      cursor: pointer;
    }
    &_active {
      min-width: 200px;
      padding: 10px 24px;
      color: var(--Wohui-White, #fff);
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      border-radius: 4px;
      background: #faae56;
      margin-right: 31px;
      cursor: pointer;
    }
  }

  @media screen and (max-width: 768px) {
    width: 95%;
    margin-left: auto;
    margin-right: auto;
    height: auto;
    padding-bottom: 32px;

    & > .about_btn {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 16px;
      row-gap: 16px;

      & > .about_btn_left {
        min-width: auto;
        margin-right: 0;
      }

      & > .about_btn_active {
        min-width: auto;
        margin-right: 0;
      }
    }
  }
}
</style>
